import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import './index.modules.css';

interface ListLoaderGuardProps {
  isLoading: boolean | undefined;
  classNames?: {
    container?: string;
  };
}

export function ListLoaderGuard({ isLoading, classNames }: ListLoaderGuardProps) {
  if (!isLoading) return null;

  return (
    <div className={flattenClassNames(['absolute -top-4 w-full', classNames?.container])}>
      {/* loading-bar class is a custom vanilla CSS class. */}
      {/* Left it where it is, so it doesn't get mixed with Tailwind's classes */}
      <div className={flattenClassNames(['z-10 h-1 rounded-lg bg-primary-300', 'loading-bar'])} />
    </div>
  );
}
